import { useChatBotMessages } from '../../hooks/useChatBotMessages'

import { ButtonGhost } from '@fukku/button/Ghost'
import text from 'fukku/styles/texts.module.scss'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { type TransitionEvent, useState } from 'react'
import { cx } from 'utils/cx'
import { dataTestIds } from '../../constants/dataTestIds'
import { MessageType } from '../../types/messageTypes'
import styles from './AboutAIMessage.module.scss'

export function AboutAIMessage() {
	const { t } = useLabels()
	const { hasHumanInteraction, sendHumanMessage } = useChatBotMessages()

	const [shouldShowAiInfoMessageDOM, setShouldShowAiInfoMessageDOM] = useState(
		!hasHumanInteraction
	)

	const onMoreClick = (): void => {
		sendHumanMessage({
			messageContent: t('assistant.ai.userQuestion.text'),
			responseMessageType: MessageType.AboutAI,
		})
	}

	const onAboutAITransitionEnd = (e: TransitionEvent<HTMLDivElement>): void => {
		if (e.propertyName === 'transform') {
			setShouldShowAiInfoMessageDOM(false)
		}
	}

	return shouldShowAiInfoMessageDOM ? (
		<div
			className={cx(styles.aiSuggestions, hasHumanInteraction && styles.hidden)}
			onTransitionEnd={onAboutAITransitionEnd}
			data-testid={dataTestIds.aboutAIMessage}
		>
			<p className={text.bodyS}>{t('assistant.banner.ai.text')}</p>
			<ButtonGhost className={cx(styles.moreButton)} onClick={onMoreClick}>
				{t('assistant.banner.ai.link')}
			</ButtonGhost>
		</div>
	) : null
}
